import { request } from '@/shared/api/request'

export const getPositionsByDeptType = (deptType) => {
	return request({ url: `dict/staff/positionByDeptType/${deptType}`, method: 'GET' })
}

export const getExperience = (codeGroup) => {
	return request({ url: `dict/staff/experience/${codeGroup}`, method: 'GET' })
}

export const getLevel = (codeUnit) => {
	return request({ url: `dict/staff/level/${codeUnit}`, method: 'GET' })
}

export const getUnit = (codeGroup) => {
	return request({ url: `dict/staff/unit/${codeGroup}`, method: 'GET' })
}